import React from 'react';
import ReactDOM from 'react-dom';
import 'wwtc-sdk/dist/index.css';
// colocar de primero app y luego las clases que van a hacer override de las clases css
// OJO PARA LA DOCUMENTACIÓN
import App from './App';
import './index.css';

ReactDOM.render(<App />, document.getElementById('root'));
